import {
  FETCHING_ALLOCATION_UNITS,
  FETCH_ALLOCATION_UNITS_SUCCESS,
  CREATING_ALLOCATION_UNIT,
  CREATE_ALLOCATION_UNIT_SUCCESS,
  RESET_ALLOCATION_UNIT,
  UPDATING_ALLOCATION_UNIT,
  UPDATE_ALLOCATION_UNIT_SUCCESS,
  DELETING_ALLOCATION_UNIT,
  DELETE_ALLOCATION_UNIT_SUCCESS,
  DELETE_ALLOCATION_UNIT_FAILED,
  RESET_DELETE_FAILED_FLAG,
  FETCHING_ALLOCATION_UNIT,
  FETCH_ALLOCATION_UNIT_SUCCESS,
  FETCH_ALL_ALLOCATION_UNITS_SUCCESS,
  SELECT_COST_OBJ_ALLOCATION_UNIT,
  FETCHING_ALL_ALLOCATION_UNITS
} from './AllocationUnitsConstants';

const initialState = {
  allocationUnits: [],
  fetchingAllocationUnits: false,
  allocationUnit: {},
  pageState: {
    page: 0,
    perPage: 10,
    totalEntries: 0,
    totalPages: 0
  },
  creatingAllocationUnit: false,
  fetchingAllocationUnit: false,
  updatingAllocationUnit: false,
  deletingAllocationUnit: false,
  deleteFailed: false,
  errorMessage: ''
};

const AllocationUnitsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALLOCATION_UNITS_SUCCESS:
      return {
        ...state,
        allocationUnits: action.allocationUnits.map(
          ({ id, name, description, unitCount, unitCountAvailable }) => ({
            id,
            name,
            description,
            unitCount,
            unitCountAvailable
          })
        ),
        pageState: action.pageState,
        fetchingAllocationUnits: false
      };
    case FETCHING_ALLOCATION_UNITS:
      return {
        ...state,
        fetchingAllocationUnits: true,
        pageState: {
          ...initialState.pageState,
          page: action.pageStats.page,
          perPage: action.pageStats.perPage
        }
      };
    case FETCHING_ALL_ALLOCATION_UNITS:
      return { ...state, fetchingAllocationUnits: true };
    case FETCH_ALL_ALLOCATION_UNITS_SUCCESS:
      return {
        ...state,
        fetchingAllocationUnits: false,
        allocationUnits: action.allocationUnits.map(allocationUnit => ({
          ...allocationUnit,
          disabled: false
        }))
      };
    case SELECT_COST_OBJ_ALLOCATION_UNIT: // eslint-disable-line no-case-declarations
      const { oldAllocationUnit, newAllocationUnit } = action;
      const modifiedAllocationUnits = state.allocationUnits.map(
        allocationUnit => {
          if (allocationUnit.id === newAllocationUnit)
            return { ...allocationUnit, disabled: true };
          else if (allocationUnit.id === oldAllocationUnit) {
            return { ...allocationUnit, disabled: false };
          } else return { ...allocationUnit };
        }
      );
      return {
        ...state,
        allocationUnits: modifiedAllocationUnits
      };
    case CREATING_ALLOCATION_UNIT:
      return { ...state, creatingAllocationUnit: true };
    case CREATE_ALLOCATION_UNIT_SUCCESS:
      return { ...state, creatingAllocationUnit: false };
    case RESET_ALLOCATION_UNIT:
      return { ...state, allocationUnit: { ...initialState.allocationUnit } };
    case UPDATING_ALLOCATION_UNIT:
      return { ...state, updatingAllocationUnit: true };
    case UPDATE_ALLOCATION_UNIT_SUCCESS:
      return { ...state, updatingAllocationUnit: false };
    case DELETING_ALLOCATION_UNIT:
      return { ...state, deletingAllocationUnit: true };
    case DELETE_ALLOCATION_UNIT_SUCCESS:
      return { ...state, deletingAllocationUnit: false };
    case DELETE_ALLOCATION_UNIT_FAILED:
      return {
        ...state,
        deleteFailed: true,
        errorMessage: action.errorMessage
      };
    case RESET_DELETE_FAILED_FLAG:
      return { ...state, deleteFailed: false };
    case FETCHING_ALLOCATION_UNIT:
      return { ...state, fetchingAllocationUnit: true };
    case FETCH_ALLOCATION_UNIT_SUCCESS:
      return {
        ...state,
        fetchingAllocationUnit: false,
        allocationUnit: action.allocationUnit
      };
    default:
      return { ...state };
  }
};

export default AllocationUnitsReducer;



// WEBPACK FOOTER //
// ./src/redux/allocationUnits/AllocationUnitsReducer.js